import styled from 'styled-components';

import { addMenuHeightMixin } from './styles';

interface StyledMainProps {
  $addMainMenuHeaderHeight?: boolean;
}

export const MainContainer = styled.span<StyledMainProps>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  ${addMenuHeightMixin}
`;
